import { Link } from 'react-router-dom';
import { plotSections } from '@/mocks/plot';

export default function PlotPreview() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-900">
              剧情主线
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">漫画剧情脉络速览</h2>
          </div>
          <Link
            to="/plot"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            查看完整剧情介绍
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {plotSections.map((sec, idx) => (
            <Link
              key={sec.id}
              to="/plot"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-full ${
                    idx % 2 === 0 ? 'bg-primary-500 text-background-50' : 'bg-accent-500 text-background-50'
                  }`}
                >
                  <i className={`${sec.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl text-background-300">0{idx + 1}</span>
              </div>
              <h3 className="mt-4 font-heading text-base text-foreground-950">{sec.title}</h3>
              <p className="mt-2 line-clamp-3 text-sm leading-6 text-foreground-700">{sec.body[0]}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                阅读详情
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}